require("slick-carousel")

class window.StaticPage
  constructor: ->
    @init()

  init: =>
    @initStaticSlider()

  initStaticSlider: ->
    $('.article-slider-block').each ->
      $(this).slick({
        slide: '.article-slide',
        nextArrow: $(this).parent('.article-slider-container').find('.article-slider__arrow-back')
        prevArrow: $(this).parent('.article-slider-container').find('.article-slider__arrow-next')
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
        dots: false,
        adaptiveHeight: true
      })
      $(this).on 'init reInit afterChange setPosition', (event, slick, currentSlide) ->
        padFromDiv = $(this).parent('.article-slider-container').find('.slick-arrow').height()/2
        padFromText = $(this).parent('.article-slider-container').find('.article-image-container__description').height()
        newY = ($(this).parent('.article-slider-container').find('.slick-list').height()/2) - padFromDiv - padFromText
        $(this).parent('.article-slider-container').find('.slick-arrow').css 'top', newY
        return



// WEBPACK FOOTER //
// ./assets/javascripts/app/static-page.coffee